import { Component, Input } from '@angular/core';
import { SVGIcon, xIcon } from '@progress/kendo-svg-icons';

@Component({
    selector: 'app-info-panel',
    templateUrl: './info-panel.component.html',
    styleUrls: ['./info-panel.component.scss'],
    standalone: false
})
export class InfoPanelComponent {
  @Input() title: string;
  @Input() content: string;
  svgX: SVGIcon = xIcon;
  hideInfo: boolean = false;
}
